import { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  apiEndpoint: 'https://portal.partners.api.test.romulus.live',
  dns: 'https://portal.partners.test.romulus.live',
  dashboardUrl: 'https://dashboard.test.romulus.live/autologin',
  defaultLanguage: 'en',
  supportedLanguages: [
    { locale: 'it', name: 'Italiano' },
    { locale: 'en', name: 'English' },
  ],
};
